import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from './lang/index'
import locale from 'element-ui/lib/locale'

Vue.use(VueI18n)
const lang = localStorage.getItem('lang')
const i18n = new VueI18n({
  locale: lang || 'zh',
  messages,
  silentTranslationWarn: true

})
locale.i18n((key, value) => i18n.t(key, value)) // 重点：为了实现element插件的多语言切换
export default i18n


// WEBPACK FOOTER //
// ./src/plugins/i18n/index.js